import { MessageSquare, FileSpreadsheet, AlertTriangle, PhoneOff, WifiOff } from 'lucide-react';
import { useReveal } from '@/lib/useReveal';
import { Section, Container, Display, Lead, CtaLink } from '@/components/system';

/** The pain — "¿Todavía gestionas todo por WhatsApp?" — one idea, plain words. */
const pains = [
  { icon: MessageSquare, text: 'Tus clientes te preguntan por WhatsApp dónde está su paquete.' },
  { icon: FileSpreadsheet, text: 'El control de envíos vive en Excel o en cuadernos.' },
  { icon: AlertTriangle, text: 'No sabes qué está pendiente hasta que alguien llama.' },
  { icon: PhoneOff, text: 'Tus repartidores no pueden confirmar una entrega con prueba.' },
  { icon: WifiOff, text: 'Se cae la señal en el reparto — y con ella el estado del paquete.' },
];

export function Partners() {
  const ref = useReveal<HTMLElement>();
  return (
    <Section tone="white" ref={ref}>
      <Container>
        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 lg:gap-20 items-start">
          <div className="lg:sticky lg:top-28">
            <Display data-reveal size="lg">¿Todavía gestionas todo por WhatsApp?</Display>
            <Lead data-reveal className="mt-6">
              La mayoría de las agencias de envíos a Cuba operan sin software real. Eso cuesta
              tiempo, errores y clientes. MEC lo resuelve — sin cambiar cómo trabaja tu gente.
            </Lead>
            <div data-reveal className="mt-8">
              <CtaLink to="/como-funciona">Así funciona, en tres pasos</CtaLink>
            </div>
          </div>
          <ul className="divide-y divide-line">
            {pains.map((p) => (
              <li key={p.text} data-reveal className="flex items-center gap-5 py-6">
                <div className="w-11 h-11 shrink-0 rounded-xl bg-bg-light flex items-center justify-center">
                  <p.icon className="w-5 h-5 text-text-secondary" />
                </div>
                <p className="text-lg sm:text-xl font-medium tracking-tight text-text-primary">{p.text}</p>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </Section>
  );
}
